export default __webpack_public_path__ + "static/media/icon-unacast_prox.25b8d2ef.png";